import { storageUtils } from "#shared/lib/storage-utils.ts";

const LAST_COMPANY_KEY = "gain_last_company";

export const companyStorage = {
  get(): string | null {
    return storageUtils.get(LAST_COMPANY_KEY);
  },
  set(companyId: string): void {
    storageUtils.set(LAST_COMPANY_KEY, companyId);
  },
  remove(): void {
    storageUtils.delete(LAST_COMPANY_KEY);
  },
};
